import "./path0.6aa9045e.js";


function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire383b"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire383b"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $aRPiL = parcelRequire("aRPiL");

var $78a2b0b6983be804$exports = {};
$78a2b0b6983be804$exports = import.meta.resolve("cZHEv");


var $7e6846147527ab53$exports = {};
$7e6846147527ab53$exports = import.meta.resolve("joVGs");


var $d7fa3d2a96949c0b$exports = {};
$d7fa3d2a96949c0b$exports = import.meta.resolve("e6b5y");


var $19c571e628c1997c$exports = {};
$19c571e628c1997c$exports = import.meta.resolve("ju3kW");


var $fd33489def5a4d95$exports = {};
$fd33489def5a4d95$exports = import.meta.resolve("ecwv5");


var $dc63442eefe168da$exports = {};
$dc63442eefe168da$exports = import.meta.resolve("7gWzz");


const $8a4bc95f1d88e83f$var$projects = [
    {
        id: 1,
        title: "Gesundheit",
        description: "Performing with my band, Gesundheit",
        category: "music",
        tags: [
            "Music",
            "Alt-Rock"
        ],
        media: {
            type: "video",
            src: (0, (/*@__PURE__*/$parcel$interopDefault($dc63442eefe168da$exports))),
            poster: (0, (/*@__PURE__*/$parcel$interopDefault($78a2b0b6983be804$exports))),
            alt: "Band"
        },
        featured: false
    },
    {
        id: 2,
        title: "Yale Slavic Chorus",
        description: "Cello Performance",
        category: "music",
        tags: [
            "Cello",
            "Folk-Music"
        ],
        media: {
            type: "video",
            src: (0, (/*@__PURE__*/$parcel$interopDefault($19c571e628c1997c$exports))),
            poster: (0, (/*@__PURE__*/$parcel$interopDefault($d7fa3d2a96949c0b$exports)))
        },
        link: "https://www.youtube.com/live/PIjHKVFrd8k?si=x4WXphzwH5ZCvUws&t=1440"
    },
    // {
    //     id: 3,
    //     title: "Photographs",
    //     description: "Photography and images of my creation",
    //     category: "visual",
    //     tags: ["Photography"],
    //     media: {
    //         type: "image",
    //         src: pollenPoolImg,
    //         alt: "Urban street photography"
    //     },
    //     link: "https://photos.app.goo.gl/KtZzD7D7znReAeNTA",
    // },
    {
        id: 4,
        title: "Klezmer Band",
        description: "Performance on cello with Klezmer Band",
        category: "music",
        tags: [
            "Klezmer",
            "Cello"
        ],
        media: {
            type: "video",
            src: (0, (/*@__PURE__*/$parcel$interopDefault($fd33489def5a4d95$exports))),
            poster: (0, (/*@__PURE__*/$parcel$interopDefault($d7fa3d2a96949c0b$exports)))
        },
        link: "https://slifkacenter.org/yale-klezmer-band/"
    }
];
const $8a4bc95f1d88e83f$var$categories = [
    {
        id: "all",
        label: "All Work"
    },
    {
        id: "music",
        label: "Music"
    },
    {
        id: "visual",
        label: "Visual"
    }
];
const $8a4bc95f1d88e83f$var$ExternalIcon = ()=>/*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
        width: "16",
        height: "16",
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: "currentColor",
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: "M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("polyline", {
                points: "15 3 21 3 21 9"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("line", {
                x1: "10",
                y1: "14",
                x2: "21",
                y2: "3"
            })
        ]
    });
const $8a4bc95f1d88e83f$var$MusicIcon = ()=>/*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
        width: "16",
        height: "16",
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: "currentColor",
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: "M9 18V5l12-2v13"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("circle", {
                cx: "6",
                cy: "18",
                r: "3"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("circle", {
                cx: "18",
                cy: "16",
                r: "3"
            })
        ]
    });
function $8a4bc95f1d88e83f$var$PortfolioApp() {
    const [activeCategory, setActiveCategory] = (0, $acw62.useState)("all");
    const [hoveredProject, setHoveredProject] = (0, $acw62.useState)(null);
    const filteredProjects = activeCategory === "all" ? $8a4bc95f1d88e83f$var$projects : $8a4bc95f1d88e83f$var$projects.filter((p)=>p.category === activeCategory);
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: "portfolio-container",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "background-texture"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("header", {
                className: "portfolio-header",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "header-accent"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("h1", {
                        className: "portfolio-title",
                        children: "Creative Portfolio"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                        className: "portfolio-subtitle",
                        children: "Selected work in art and music"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("nav", {
                className: "filters",
                children: $8a4bc95f1d88e83f$var$categories.map((cat)=>/*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                        onClick: ()=>setActiveCategory(cat.id),
                        className: `filter-button ${activeCategory === cat.id ? 'filter-button-active' : ''}`,
                        children: cat.label
                    }, cat.id))
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("main", {
                className: "projects-grid",
                children: filteredProjects.map((project)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("article", {
                        className: `project-card ${project.featured ? 'card-featured' : ''} ${hoveredProject === project.id ? 'card-hovered' : ''}`,
                        onMouseEnter: ()=>setHoveredProject(project.id),
                        onMouseLeave: ()=>setHoveredProject(null),
                        children: [
                            project.featured && /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                className: "featured-badge",
                                children: "Featured"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                className: "project-media",
                                children: project.media?.type === 'image' ? /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                    src: project.media.src,
                                    alt: project.media.alt,
                                    className: "media-image",
                                    onError: (e)=>{
                                        console.error(`Image failed to load: ${project.media.src}`);
                                        e.target.style.display = 'none';
                                        e.target.parentElement.innerHTML = '<div class="media-fallback">Image not found</div>';
                                    }
                                }) : project.media?.type === 'video' ? /*#__PURE__*/ (0, $ayMG0.jsxs)("video", {
                                    controls: true,
                                    poster: project.media.poster,
                                    className: "media-video",
                                    onError: (e)=>{
                                        console.error(`Video failed to load: ${project.media.src}`);
                                        e.target.style.display = 'none';
                                        e.target.parentElement.innerHTML = '<div class="media-fallback">Video not found</div>';
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("source", {
                                            src: project.media.src,
                                            type: "video/mp4"
                                        }),
                                        "Your browser does not support the video tag."
                                    ]
                                }) : /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    className: "media-fallback",
                                    children: "No media available"
                                })
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "card-content",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        className: "category-indicator",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                className: `category-dot ${project.category === 'music' ? 'dot-music' : 'dot-visual'}`
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                className: "category-label",
                                                children: project.category
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                                        className: "card-title",
                                        children: project.title
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                        className: "card-description",
                                        children: project.description
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                        className: "tags",
                                        children: project.tags.map((tag)=>/*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                className: "tag",
                                                children: tag
                                            }, tag))
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        className: "links",
                                        children: [
                                            project.spotify && /*#__PURE__*/ (0, $ayMG0.jsxs)("a", {
                                                href: project.spotify,
                                                className: "project-link",
                                                target: "_blank",
                                                rel: "noopener noreferrer",
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)($8a4bc95f1d88e83f$var$MusicIcon, {}),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                        children: "Listen"
                                                    })
                                                ]
                                            }),
                                            project.link && /*#__PURE__*/ (0, $ayMG0.jsxs)("a", {
                                                href: project.link,
                                                className: "project-link",
                                                target: "_blank",
                                                rel: "noopener noreferrer",
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)($8a4bc95f1d88e83f$var$ExternalIcon, {}),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                        children: "View"
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                className: "corner-accent"
                            })
                        ]
                    }, project.id))
            })
        ]
    });
}
const $8a4bc95f1d88e83f$var$root = (0, $aRPiL.createRoot)(document.getElementById('root'));
$8a4bc95f1d88e83f$var$root.render(/*#__PURE__*/ (0, $ayMG0.jsx)($8a4bc95f1d88e83f$var$PortfolioApp, {}));
var $8a4bc95f1d88e83f$export$2e2bcd8739ae039 = $8a4bc95f1d88e83f$var$PortfolioApp;


//# sourceMappingURL=creative_portfolio.43295094.js.map
